import { useState } from "react";
import { GlobalFilterConfig, GlobalFilterValues } from "./types";

const createDefaultValues = (globalFilters: Array<GlobalFilterConfig>) => {
    const defaults: GlobalFilterValues = {};
    globalFilters.forEach((globalFilter) => {
        if (globalFilter.type === "datePreset") defaults[globalFilter.key] = globalFilter.defaultPreset;
        else if (globalFilter.type === "choice") defaults[globalFilter.key] = globalFilter.defaultValue;
        else defaults[globalFilter.key] = null;
    });
    return defaults;
};

export const useGlobalFilterValues = (globalFilters: Array<GlobalFilterConfig>) => {
    const [values, setValues] = useState<GlobalFilterValues>(() => createDefaultValues(globalFilters));

    const setValue = (filterKey: string, value: string | number | null) => {
        setValues((currentValues) => ({ ...currentValues, [filterKey]: value }));
    };

    return { values, setValue };
};
